// polyfill Object.fromEntries
const objectFromEntriesPolyfill = (arr) =>
  arr.reduce((obj, [k, v]) => {
    const newObj = obj;
    newObj[k] = v;
    return newObj;
  }, {});
Object.fromEntries = Object.fromEntries ? Object.fromEntries : objectFromEntriesPolyfill;

// convert an object's keys to arrays (a multivalue map)
export const objectValuesToArrays = (obj) => objectMap(valuesToArray)(obj);

// map any func to object key/value: objectMap f {a: 1, b:2} -> {a: f(a,1), b: f(b,2)}
export const objectMap = (f) => (obj) =>
  Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, f([key, value])]));

// converts object value to array: {key: value} -> {key: [value]}
const valuesToArray = ([, value]) => toArray(value);

// filters an object's keys by a whitelist
export const filterObjByKeys = (obj, validKeys) =>
  Object.fromEntries(Object.entries(obj).filter(([key]) => validKeys.includes(key)));

export const toArray = (obj = []) => (Array.isArray(obj) ? obj : [obj]);

export const firstItem = (arr) => (Array.isArray(arr) && arr[0] ? arr[0] : null);
export const lastItem = (arr) => (Array.isArray(arr) && arr.length > 0 ? arr[arr.length - 1] : null);
export const firstKey = (obj) => Object.keys(obj)[0];

// last part of a path: /abc/efg/myfile.html -> myfile.html
export const lastPart = (path) => (path ? lastItem(path.split("/")) : null);

export const unqiueElems = (arr) => arr.filter((value, index, self) => self.indexOf(value) === index);
export const arrayUniqueByKey = (arr, key, distinct = []) =>
  arr.filter((item) => (distinct.includes(item[key]) ? false : distinct.push(item[key])));
// const arrayUniqueByKey2 = (array, key) => [...new Map(array.map(item =>[item[key], item])).values()]; // No IE11 support

// insert element into
export const insert = (arr, index, newItem) => [...arr.slice(0, index), ...newItem, ...arr.slice(index)];

// join two multimaps - merge({a:[1]},{a:[2]) b:[1]} -> {a:[1,2], b:[1]}
export const merge = (a, b) => {
  if (!a && !b) return {}; // next 3 lines: old web@work compatability fix attempt
  if (!a) return b;
  if (!b) return a;

  return Object.fromEntries([
    ...Object.entries(a).map(([k, v]) => [k, (v || []).concat(b[k] || [])]),
    ...Object.entries(b).map(([k, v]) => [k, (v || []).concat(a[k] || [])]),
  ]);
};

// remove an element from multi map
export const removeKey = (k, v, arr) => {
  const newArr = arr;
  newArr[k] = (newArr[k] || []).filter((item) => !(item === v));
  if (!newArr[k]) delete newArr[k];
  return newArr;
};

// pipe(f1,f2,f3,f4)(obj) === f4(f3(f2(f1(obj))))
export const pipe =
  (...fns) =>
  (x) =>
    fns.reduce((v, f) => f(v), x);

// truncate a long string by length l with postfix '...':
export const truncate = (str, length, elipsis = "...") =>
  str && length && str.length > length ? str.substr(0, length) + elipsis : str;

export const noop = () => {};

export const preventDefault = (ev) => ev?.preventDefault();

export const uuid = (prefix) => (prefix ? `${prefix.toString()}-${new Date().getTime()}` : new Date().getTime());

export const uniqueKey = (key, idx) => `${key}-${idx}`;

// For OS queries use
export const dateFilters = ({ fromDate, toDate }) => [
  ...(fromDate ? [{ range: { publicationDate: { gte: firstItem(fromDate) } } }] : []),
  ...(toDate ? [{ range: { publicationDate: { lte: firstItem(toDate) } } }] : []),
];
